// extracted by mini-css-extract-plugin
export default {"carousel":"Carousel_carousel__5ODO4","carouselItems":"Carousel_carouselItems__aVza2","mobile":"Carousel_mobile__X6hjo"};